const HOSTS = {
  account: process.env.REACT_APP_HOSTS_ACCOUNT,
  api: process.env.REACT_APP_HOSTS_API,
  compression: process.env.REACT_APP_HOSTS_COMPRESSION,
  publisher: process.env.REACT_APP_HOSTS_PUBLISHER,
  reporter: process.env.REACT_APP_HOSTS_REPORTER,
  audience: process.env.REACT_APP_HOSTS_AUDIENCE,
  bidder: process.env.REACT_APP_HOSTS_BIDDER,
  geodb: process.env.REACT_APP_HOSTS_GEODB,
  content: process.env.REACT_APP_HOSTS_CONTENT,
  billingReporter: process.env.REACT_APP_HOSTS_BILLING_REPORTER,
};

export const AUTH_TOKENS = {};

export const CLIENT_HOSTS = {
  prod: /admin\.dataseat\.(com|tv)/,
  alpha: /admin-alpha\.dataseat\.(com|tv)/,
  alphaDevCluster: /admin-alpha.([\w\d]+).dataseat.(org|ninja)/,
  devCluster: /admin.([\w\d]+).dataseat.(org|ninja)/,
  local: "localhost",
};

export const isDevClusterAlpha = CLIENT_HOSTS.alphaDevCluster.test(
  document?.location?.hostname
); //alpha instance running on dev cluster
export const isDevCluster = CLIENT_HOSTS.devCluster.test(
  document?.location?.hostname
); //regular instance running on dev cluster
export const isDev = isDevClusterAlpha || isDevCluster;
const isDeployedAlpha = CLIENT_HOSTS.alpha.test(document?.location?.hostname); //alpha instance on dataseat.com
export const isAlpha = isDevClusterAlpha || isDeployedAlpha;
export const isLocal = document?.location?.hostname
  .split(".")
  .includes(CLIENT_HOSTS.local);
export const isLAN = /^192\.168\..+/.test(window.location.host);

export default HOSTS;
